// Shared style tokens for the Access Management tab, so the dialog and the table cells
// can't drift apart.

// Uppercase micro-labels, same as the app's other cards/tables (see
// components/reviewsLeaderboard/LeaderboardTable.jsx's HEAD_SX).
export const SECTION_LABEL_SX = {
  fontFamily: "Quicksand",
  fontWeight: 800,
  fontSize: 11,
  color: "#9CA3AF",
  textTransform: "uppercase",
  letterSpacing: 1,
};

// Same gradient primary the rest of the app uses for its main action (see
// components/plans/Plans.jsx's "New Plan").
//
// The &.Mui-disabled block is load-bearing: MUI greys a disabled contained button via
// `background-color`, which the `background` shorthand above wins against — so without it
// a disabled button keeps the full-strength orange gradient and only the label greys out,
// which reads as an enabled button with unreadable text.
export const PRIMARY_BTN_SX = {
  textTransform: "none",
  fontFamily: "Quicksand",
  fontWeight: 700,
  borderRadius: "10px",
  boxShadow: "0 2px 8px rgba(255,82,0,0.3)",
  background: "linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)",
  "&:hover": { background: "linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)", opacity: 0.9 },
  "&.Mui-disabled": {
    background: "#EFEFEF",
    color: "#B6B6B6",
    boxShadow: "none",
  },
};

// Secondary/cancel action alongside the above.
export const SECONDARY_BTN_SX = {
  textTransform: "none",
  fontFamily: "Quicksand",
  fontWeight: 700,
  color: "#6B7280",
};
